<div class="dalog-header-cust">
  <h2>
    <b>{{ userData?.gradeName }}</b> Grade Details
  </h2>
  <button
    type="button"
    class="btn-cust-close"
    (click)="navService.openSideNav({ toogle: true })"
  >
    <i class="icon-close"></i>
  </button>
</div>
<!-- <button class="btn-cust-close-float top-15" (click)="navService.openSideNav({ toogle: true })">
  <i class="icon-close"></i>
</button> -->
<!-- <mat-toolbar class="mat-elevation-z0">
  <mat-toolbar-row>
    <div class="notificard">
      <h2>
        <b>{{ userData?.gradeName }}</b> Grade Details
      </h2>
    </div>
  </mat-toolbar-row>
</mat-toolbar> -->
<div class="side-drawer-content contact">
  <div>
    <div class="user-info grade-drawer" *ngIf="!isLoading; else gradeDetailsSkeleton">
      <div class="gd-section-title">Employee Details</div>
      <div class="ent-card gd-profile">
        <div class="ent-head">
          <div class="ent-icon gd-avatar">{{ initials(userData?.userFullName) }}</div>
          <div class="ent-title">
            <span class="ent-title-main">{{ userData?.userFullName || "—" }}</span>
            <span class="ent-title-sub">{{ userData?.companyAccountName || "—" }}</span>
          </div>
          @if (userData?.gradeName) {
            <span class="gd-grade">Grade {{ userData?.gradeName }}</span>
          }
        </div>
        <div class="gd-facts">
          <div class="gd-fact">
            <span>Department</span>
            <b [title]="userData?.departmentName || ''">{{ userData?.departmentName || "—" }}</b>
          </div>
          <div class="gd-fact">
            <span>Employee Code</span>
            <b>{{ userData?.employeeCode || "—" }}</b>
          </div>
          <div class="gd-fact">
            <span>SAP Code</span>
            <b>{{ userData?.sapCode || "—" }}</b>
          </div>
        </div>
      </div>

      <div class="gd-section-title">Travel Entitlements</div>
      <div class="ent-card">
        <div class="ent-head">
          <div class="ent-icon">₹</div>
          <div class="ent-title">
            <span class="ent-title-main">Applicable limits</span>
            <span class="ent-title-sub">As per grade {{ userData?.gradeName }} policy</span>
          </div>
        </div>

        @if (userData?.isMetroCities || userData?.otherCities || userData?.isTCities) {
          <div class="ent-group">
            <div class="ent-group-title">Lodging</div>
            <div class="ent-row" *ngIf="userData?.isMetroCities">
              <span class="ent-label">Metro City</span>
              <b class="ent-amt">{{ userData?.metroCitiesUptoAmount | currency: "INR" }}</b>
            </div>
            <div class="ent-row" *ngIf="userData?.otherCities">
              <span class="ent-label">Other City</span>
              <b class="ent-amt">{{ userData?.otherCitiesUptoAmount | currency: "INR" }}</b>
            </div>
            <ng-container *ngIf="userData?.isTCities">
              @for (tier of lodgingTiers(); track tier.label) {
                <div class="ent-row">
                  <span class="ent-label">
                    <app-city-lodging-item
                      [cityLabel]="tier.label"
                      [cityNames]="tier.names"
                    ></app-city-lodging-item>
                    City
                  </span>
                  @if (tier.actual) {
                    <span class="ent-actuals">Actuals</span>
                  } @else {
                    <b class="ent-amt">{{ tier.amount | currency: "INR" }}</b>
                  }
                </div>
                @if (userData?.isLodgingWithRelatives) {
                  <div class="ent-row ent-sub">
                    <span class="ent-label">With relatives</span>
                    @if (tier.wrActual) {
                      <span class="ent-actuals">Actuals</span>
                    } @else {
                      <b class="ent-amt">{{ tier.wrAmount | currency: "INR" }}</b>
                    }
                  </div>
                }
              }
            </ng-container>
          </div>
        }

        <div class="ent-group">
          <div class="ent-group-title">Meals &amp; Allowances</div>
          <div class="ent-row">
            <span class="ent-label">{{ userData?.foodAmountWithoutBill ? "Fooding (with bill)" : "Fooding" }}</span>
            @if (userData?.isFoodActuals) {
              <span class="ent-actuals">Actuals</span>
            } @else {
              <b class="ent-amt">{{ userData?.budgetAmount | currency: "INR" }}</b>
            }
          </div>
          <div class="ent-row" *ngIf="userData?.foodAmountWithoutBill">
            <span class="ent-label">Fooding (without bill)</span>
            <b class="ent-amt">{{ userData?.foodAmountWithoutBill ?? 0 | currency: "INR" }}</b>
          </div>
          <div class="ent-row" *ngIf="userData?.isBillRequired !== undefined && userData?.isBillRequired !== null">
            <span class="ent-label">Bill required for food</span>
            @if (userData?.isBillRequired) {
              <span class="ent-tag ent-tag-yes">Yes</span>
            } @else {
              <span class="ent-tag ent-tag-warn">No · {{ userData?.deductionPercentage ?? 0 }}% deduction</span>
            }
          </div>
          <div class="ent-row">
            <span class="ent-label">Daily Allowance (DA)</span>
            @if (userData?.isDailyAllowanceActuals) {
              <span class="ent-actuals">Actuals</span>
            } @else {
              <b class="ent-amt">{{ userData?.da | currency: "INR" }}</b>
            }
          </div>
        </div>

        @if (travelClass.length) {
          <div class="ent-group">
            <div class="ent-group-title">Travel Class</div>
            <div class="gd-classes">
              @for (item of travelClass; track $index) {
                @if (item.trim()) {
                  <span class="gd-class">{{ item.trim() }}</span>
                }
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<ng-template #gradeDetailsSkeleton>
  <div class="user-info grade-drawer">
    <div class="gd-section-title">Employee Details</div>
    <div class="ent-card gd-profile">
      <div class="ent-head">
        <ngx-skeleton-loader [theme]="{ width: '34px', height: '34px', 'border-radius': '50%', margin: 0 }" />
        <div class="ent-title">
          <ngx-skeleton-loader style="display: block" [theme]="{ width: '140px', height: '14px', margin: 0 }" />
          <ngx-skeleton-loader style="display: block" [theme]="{ width: '180px', height: '10px', margin: '4px 0 0 0' }" />
        </div>
      </div>
      <div class="gd-facts">
        @for (item of [1, 2, 3]; track $index) {
          <div class="gd-fact">
            <ngx-skeleton-loader style="display: block" [theme]="{ width: '70px', height: '9px', margin: 0 }" />
            <ngx-skeleton-loader style="display: block" [theme]="{ width: '60%', height: '13px', margin: '4px 0 0 0' }" />
          </div>
        }
      </div>
    </div>
    <div class="gd-section-title">Travel Entitlements</div>
    <div class="ent-card">
      <div class="ent-head">
        <ngx-skeleton-loader [theme]="{ width: '34px', height: '34px', 'border-radius': '50%', margin: 0 }" />
        <ngx-skeleton-loader style="display: block; flex: 1" [theme]="{ width: '60%', height: '14px', margin: 0 }" />
      </div>
      <div class="ent-group">
        @for (item of [1, 2, 3, 4, 5, 6]; track $index) {
          <div class="ent-row">
            <ngx-skeleton-loader [theme]="{ width: '110px', height: '11px', margin: 0 }" />
            <ngx-skeleton-loader [theme]="{ width: '70px', height: '11px', margin: 0 }" />
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>
